module.exports = __webpack_public_path__ + "img/CM-SS-CA-Acura-Playful.7abb6de0.jpeg";